import React, { useEffect, useState } from "react";
import HeaderFive from "../../../components/HeaderFive";
import FooterAreaFour from "../../../components/FooterAreaFour";
import Breadcrumb from "../../../components/Breadcrumb";
import PartgroupSection from "components/dashboard-components/product/PartGroupSelection";
import Preloader from "../../../helper/Preloader";
import axios from "axios";
import API_BASE_URL from "../../../config";
import { useParams } from 'react-router-dom';

const PartGroupPage = () => {
  const { id } = useParams();
    const [Modelveriant, setCarModelveriant] = useState([]);
    let [active, setActive] = useState(true);
  
    useEffect(() => {
      setTimeout(function () {
        setActive(false);
      }, 2000);
    }, []);
  
  
    
    useEffect(() => {
      const fetchCarMakes = async () => {
        try {
          const response = await axios.get(`${API_BASE_URL}api/home/model_variant_item/${id}/`);
          setCarModelveriant(response.data);
        } catch (error) {
          console.error('Error fetching car makes:', error);
        }
      };
     
      fetchCarMakes();
    }, []);
  return (
    <>
      {active === true && <Preloader />}
      <HeaderFive />

      <Breadcrumb title={Modelveriant.name} />
       <PartgroupSection id={id} Modelveriant={Modelveriant}/>
      <FooterAreaFour />
    </>
  );
};

export default PartGroupPage;
